export function WorkspaceCardSkeleton() {
  return (
    <div className="bg-background/50 border border-gray-200 dark:border-gray-700 rounded-xl min-h-[64px] p-4 sm:p-5 animate-pulse">
      {/* Header row - title and role skeleton */}
      <div className="flex items-baseline gap-3 mb-2">
        <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-32"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-full w-12 -translate-y-0.5"></div>
      </div>

      {/* Meta row - members skeleton */}
      <div className="flex items-center gap-2">
        <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-16"></div>
        <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1"></div>
        <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-20"></div>
      </div>
    </div>
  );
}